"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.SORTING_MENU = exports.SORTING = void 0;
const SORTING = exports.SORTING = 'sorting';
const SORTING_MENU = exports.SORTING_MENU = 'sorting-menu';
